/* eslint-disable prettier/prettier */
import store from "@/store"
import Swal from "sweetalert2/dist/sweetalert2.min.js";
const isAuthenticatedGuard =async(to, from, next)=>{
   
    const {ok} = await store.dispatch("auth/checkAuthentication")
    if(ok){
        next()
    }else {
        Swal.fire({
            title: "Sesión Expirada",
            text: "Por favor vuelva a ingresar sus credenciales.",
            icon: "info",
            buttonsStyling: false,
            confirmButtonText: "Continuar",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          });
    next({name:'sign-in'})
    }
}
export default isAuthenticatedGuard